export default __webpack_public_path__ + "static/media/Card.c48cdee8.svg";